// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/two-step-fluid-application.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/two-step-fluid-application/two-step-fluid-application.js';

mount([g0]);
